// removed by extract-text-webpack-plugin
module.exports = {"bitBackground":"_2DEShn3ZftgptBnBTD04ch","isLighter":"_21zpSKoR-NY8wn8BmcR4Qc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BitBackground/BitBackground.css
// module id = 173
// module chunks = 0